import { checkBESeamlessEnable } from '@pm/super-library-2/modules/seamless';

import { seamlessConstant } from '../constant';

export const seamlessAction = {
    checkSeamless,
    getSeamlessMemberWallet,
    isApplyingPromotionId,
    getSeamlessAllProviderWallets,
    updateSeamlessProviderWallets,
    getTotalTransferWalletBalance,
    getSeamlessPromotionQueueData,
    isSeamlessPromotionExist,
    seamlessPromotionData,
    getTransferWallet,
    updateSeamlessTransferWallets,
    updateSelectedSeamlessPromo,
    updateSeamlessPromoList,
    updateLoadWallet,
    useCheckSeamlessEnable,
};

function checkSeamless(isSeamless) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.CHECK_SEAMLESS, payload: { isSeamless: isSeamless } });
    };
}

function getSeamlessMemberWallet(seamlessMemberWallet) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.GET_MEMBER_WALLET, payload: { memberWallet: seamlessMemberWallet } });
    };
}

function isApplyingPromotionId(id) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.IS_APPLYING_PROMOTION_ID, payload: { isApplyingPromotionId: id } });
    };
}

function getSeamlessAllProviderWallets(providerWallets) {
    providerWallets = providerWallets.filter((a) => a.provider !== null);
    return (dispatch) => {
        dispatch({ type: seamlessConstant.GET_SEAMLESS_ALL_PROVIDER_WALLETS, payload: { providerWallets: providerWallets } });
    };
}

function updateSeamlessProviderWallets(seamlessProviderWallets) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.UPDATE_SEAMLESS_PROVIDER_WALLETS, payload: { seamlessProviderWallets: seamlessProviderWallets } });
    };
}

function getTotalTransferWalletBalance(amount) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.GET_TOTAL_TRANSFER_WALLET_BALANCE, payload: { totalTransferWalletBalance: amount } });
    };
}

function getSeamlessPromotionQueueData(data) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.GET_SEAMLESS_PROMOTION_QUEUE_DATA, payload: { seamlessPromotionQueueData: data } });
    };
}

function isSeamlessPromotionExist(data) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.IS_SEAMLESS_PROMOTION_EXIST, payload: { isSeamlessPromotionExist: data } });
    };
}
function seamlessPromotionData(data) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.SEAMLESS_PROMOTION_DATA, payload: { seamlessPromotionData: data } });
    };
}

function getTransferWallet(data) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.GET_TRANSFER_WALLET, payload: { transferWallet: data } });
    };
}

function updateSeamlessTransferWallets(data) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.UPDATE_SEAMLESS_TRANSFER_WALLETS, payload: { seamlessTransferWallets: data } });
    };
}

function updateLoadWallet(loadWallet) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.UDPATE_LOAD_WALLET, payload: { loadWallet } });
    };
}

function useCheckSeamlessEnable(currencyLang, seamlessEnabled) {
    return async (dispatch, getState) => {
        const state = getState();
        const { seamless } = state;

        if (seamless.seamlessFeatureFetchStatus !== 'idle') {
            return;
        }

        const isFullSeamless = window.portalSettings?.features?.isFullSeamless;
        const isSeamlessEnabled = seamlessEnabled || isFullSeamless === true;
        const enabledSeamless = isSeamlessEnabled && !window.isAffiliate;

        if (!enabledSeamless) {
            dispatch({ type: seamlessConstant.SET_SEAMLESS_FETCH_STATUS, payload: { seamlessFeatureFetchStatus: 'complete' } });
            return;
        }

        dispatch({ type: seamlessConstant.SET_SEAMLESS_FETCH_STATUS, payload: { seamlessFeatureFetchStatus: 'loading' } });

        try {
            const res = await checkBESeamlessEnable(window.merchantCode, currencyLang);
            dispatch({ type: seamlessConstant.CHECK_SEAMLESS, payload: { isSeamless: res === true } });
        } catch (err) {
            dispatch({ type: seamlessConstant.CHECK_SEAMLESS, payload: { isSeamless: false } });
        } finally {
            dispatch({ type: seamlessConstant.SET_SEAMLESS_FETCH_STATUS, payload: { seamlessFeatureFetchStatus: 'complete' } });
        }
    };
}

function updateSelectedSeamlessPromo(data) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.UPDATE_SELECTED_SEAMLESS_PROMO_ID, payload: { selectedSeamlessPromoObj: data } });
    };
}

function updateSeamlessPromoList(data) {
    return (dispatch) => {
        dispatch({ type: seamlessConstant.UPDATE_SEAMLESS_PROMO_LIST, payload: { promoList: data } });
    };
}
